// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.zone-assets-dialog {
  display: flex;
  width: 100%;
  max-height: min(82vh, 850px);
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  background: var(--ca-surface, #fff);
  color: var(--ca-text-primary, #172033);
}

.dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
  padding: 1.35rem 1.5rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: linear-gradient(180deg, #fbfcff 0%, #f7f9fd 100%);
}

.dialog-heading-group {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 0.9rem;
}

.dialog-heading-icon {
  display: inline-flex;
  width: 2.8rem;
  height: 2.8rem;
  flex: 0 0 2.8rem;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(40, 80, 173, 0.12);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.2rem;
}

.dialog-heading-copy {
  min-width: 0;
}
.dialog-heading-copy h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.15rem, 2vw, 1.45rem);
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.eyebrow {
  margin: 0 0 0.3rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.dialog-subtitle {
  margin: 0.35rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.84rem;
  line-height: 1.5;
}

.icon-button {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 2.25rem;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid transparent;
  border-radius: var(--ca-radius-md, 8px);
  background: transparent;
  color: var(--ca-text-tertiary, #6f7b91);
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
}
.icon-button:hover {
  border-color: var(--ca-border-light, #e9edf3);
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-primary, #0e2e80);
}
.icon-button:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
}

.dialog-body {
  min-height: 12rem;
  padding: 1.25rem 1.5rem;
  overflow: auto;
  background: var(--ca-bg, #f5f7fb);
}

.zone-summary {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 0.8rem 0.95rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface, #fff);
}

.summary-icon {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 2.25rem;
  align-items: center;
  justify-content: center;
  border-radius: var(--ca-radius-sm, 6px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1rem;
}

.summary-copy {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.1rem;
}
.summary-copy strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.87rem;
  font-weight: 700;
}
.summary-copy span {
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.76rem;
}

.summary-status {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem 0.55rem;
  border-radius: 999px;
  background: var(--ca-success-bg, #eaf7f0);
  color: var(--ca-success, #198754);
  font-size: 0.7rem;
  font-weight: 700;
}

.assets-table-card {
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.table-card-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.1rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: var(--ca-surface, #fff);
}
.table-card-heading h3 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.95rem;
  font-weight: 700;
}
.table-card-heading p {
  margin: 0.25rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.77rem;
  line-height: 1.45;
}

.asset-count {
  display: inline-flex;
  min-width: 1.9rem;
  height: 1.9rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0 0.4rem;
  border-radius: 999px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.75rem;
  font-weight: 800;
}

.table-region {
  min-width: 0;
  overflow-x: auto;
  padding: 0.5rem;
  background: var(--ca-surface, #fff);
}

.state-panel {
  display: flex;
  min-height: 17rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
}
.state-panel h3 {
  margin: 0 0 0.45rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.05rem;
  font-weight: 700;
}
.state-panel p {
  max-width: 28rem;
  margin: 0 0 1rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.84rem;
  line-height: 1.55;
}

.loading-state,
.empty-state,
.error-state {
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  margin-bottom: 1rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: zone-assets-spin 0.8s linear infinite;
}

.state-icon {
  display: inline-flex;
  width: 3.2rem;
  height: 3.2rem;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 1rem;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.5rem;
}

.error-state .state-icon {
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
}

.btn {
  display: inline-flex;
  min-height: 2.5rem;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.55rem 0.95rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.84rem;
  font-weight: 650;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.btn-primary {
  border: 1px solid var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}
.btn-primary:hover {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
  color: #fff;
}

.btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}
.btn-secondary:hover {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-primary-dark, #0d2863);
}

.btn:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.95rem 1.5rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
  background: var(--ca-surface, #fff);
}

.footer-note {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.76rem;
}
.footer-note i {
  color: var(--ca-success, #198754);
  font-size: 0.95rem;
}

@keyframes zone-assets-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 767.98px) {
  .dialog-header {
    gap: 0.75rem;
    padding: 1rem;
  }
  .dialog-heading-group {
    gap: 0.65rem;
  }
  .dialog-heading-icon {
    width: 2.35rem;
    height: 2.35rem;
    flex-basis: 2.35rem;
    font-size: 1rem;
  }
  .dialog-body {
    padding: 0.9rem;
  }
  .zone-summary {
    flex-wrap: wrap;
    gap: 0.6rem;
  }
  .summary-status {
    margin-left: 3rem;
  }
  .table-card-heading {
    align-items: flex-start;
    padding: 0.9rem;
  }
  .table-region {
    padding: 0.25rem;
  }
  .dialog-footer {
    padding: 0.85rem 1rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/zone-management/zone/zone-assets/zone-assets.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,4BAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,mCAAA;EACA,sCAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,uBAAA;EACA,wDAAA;EACA,6DAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,oBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;AACF;AACE;EACE,SAAA;EACA,sCAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AACJ;;AAGA;EACE,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,6BAAA;EACA,uCAAA;EACA,uBAAA;EACA,uCAAA;EACA,eAAA;EACA,kFAAA;AAAF;AAEE;EACE,6CAAA;EACA,4CAAA;EACA,iCAAA;AAAJ;AAGE;EACE,0CAAA;EACA,mBAAA;AADJ;;AAKA;EACE,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,iCAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,iDAAA;EACA,uCAAA;EACA,mCAAA;AAFF;;AAKA;EACE,oBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;AAFF;AAIE;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,wCAAA;EACA,kBAAA;AAHJ;;AAOA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,yCAAA;EACA,iCAAA;EACA,iBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,YAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,wDAAA;EACA,mCAAA;AAJF;AAME;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;AALJ;;AASA;EACE,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;AANF;;AASA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;AANF;;AASA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AANF;AAQE;EACE,mBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AANJ;AASE;EACE,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;AAPJ;;AAWA;;;EAGE,iDAAA;EACA,wCAAA;EACA,mCAAA;AARF;;AAWA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,4CAAA;EACA,kBAAA;EACA,gDAAA;AARF;;AAWA;EACE,oBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;EACA,mBAAA;EACA,6CAAA;EACA,iCAAA;EACA,iBAAA;AARF;;AAWA;EACE,wCAAA;EACA,gCAAA;AARF;;AAWA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,wBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uFAAA;AARF;;AAWA;EACE,4CAAA;EACA,sCAAA;EACA,WAAA;AARF;AAUE;EACE,6CAAA;EACA,2CAAA;EACA,WAAA;AARJ;;AAYA;EACE,2CAAA;EACA,mCAAA;EACA,iCAAA;AATF;AAWE;EACE,wCAAA;EACA,4CAAA;EACA,sCAAA;AATJ;;AAaA;EACE,0CAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,qDAAA;EACA,mCAAA;AAVF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uCAAA;EACA,kBAAA;AAVF;AAYE;EACE,iCAAA;EACA,kBAAA;AAVJ;;AAcA;EACE;IAAK,yBAAA;EAVL;AACF;AAYA;EACE;IACE,YAAA;IACA,aAAA;EAVF;EAaA;IACE,YAAA;EAXF;EAcA;IACE,cAAA;IACA,eAAA;IACA,mBAAA;IACA,eAAA;EAZF;EAeA;IACE,eAAA;EAbF;EAgBA;IACE,eAAA;IACA,WAAA;EAdF;EAiBA;IACE,iBAAA;EAfF;EAkBA;IACE,uBAAA;IACA,eAAA;EAhBF;EAmBA;IACE,gBAAA;EAjBF;EAoBA;IACE,qBAAA;EAlBF;AACF;AAqBA;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;EAnBF;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.zone-assets-dialog {\n  display: flex;\n  width: 100%;\n  max-height: min(82vh, 850px);\n  min-width: 0;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--ca-surface, #fff);\n  color: var(--ca-text-primary, #172033);\n}\n\n.dialog-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.25rem;\n  padding: 1.35rem 1.5rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: linear-gradient(180deg, #fbfcff 0%, #f7f9fd 100%);\n}\n\n.dialog-heading-group {\n  display: flex;\n  min-width: 0;\n  align-items: flex-start;\n  gap: 0.9rem;\n}\n\n.dialog-heading-icon {\n  display: inline-flex;\n  width: 2.8rem;\n  height: 2.8rem;\n  flex: 0 0 2.8rem;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(40, 80, 173, 0.12);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.2rem;\n}\n\n.dialog-heading-copy {\n  min-width: 0;\n\n  h2 {\n    margin: 0;\n    color: var(--ca-text-primary, #172033);\n    font-size: clamp(1.15rem, 2vw, 1.45rem);\n    font-weight: 700;\n    line-height: 1.35;\n    overflow-wrap: anywhere;\n  }\n}\n\n.eyebrow {\n  margin: 0 0 0.3rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n}\n\n.dialog-subtitle {\n  margin: 0.35rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.84rem;\n  line-height: 1.5;\n}\n\n.icon-button {\n  display: inline-flex;\n  width: 2.25rem;\n  height: 2.25rem;\n  flex: 0 0 2.25rem;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid transparent;\n  border-radius: var(--ca-radius-md, 8px);\n  background: transparent;\n  color: var(--ca-text-tertiary, #6f7b91);\n  cursor: pointer;\n  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    border-color: var(--ca-border-light, #e9edf3);\n    background: var(--ca-surface-hover, #f8faff);\n    color: var(--ca-primary, #0e2e80);\n  }\n\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 2px;\n  }\n}\n\n.dialog-body {\n  min-height: 12rem;\n  padding: 1.25rem 1.5rem;\n  overflow: auto;\n  background: var(--ca-bg, #f5f7fb);\n}\n\n.zone-summary {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  padding: 0.8rem 0.95rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface, #fff);\n}\n\n.summary-icon {\n  display: inline-flex;\n  width: 2.25rem;\n  height: 2.25rem;\n  flex: 0 0 2.25rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--ca-radius-sm, 6px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1rem;\n}\n\n.summary-copy {\n  display: flex;\n  min-width: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 0.1rem;\n\n  strong {\n    color: var(--ca-text-primary, #172033);\n    font-size: 0.87rem;\n    font-weight: 700;\n  }\n\n  span {\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.76rem;\n  }\n}\n\n.summary-status {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.3rem 0.55rem;\n  border-radius: 999px;\n  background: var(--ca-success-bg, #eaf7f0);\n  color: var(--ca-success, #198754);\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.assets-table-card {\n  min-width: 0;\n  overflow: hidden;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.table-card-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1.1rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: var(--ca-surface, #fff);\n\n  h3 {\n    margin: 0;\n    color: var(--ca-text-primary, #172033);\n    font-size: 0.95rem;\n    font-weight: 700;\n  }\n\n  p {\n    margin: 0.25rem 0 0;\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.77rem;\n    line-height: 1.45;\n  }\n}\n\n.asset-count {\n  display: inline-flex;\n  min-width: 1.9rem;\n  height: 1.9rem;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0.4rem;\n  border-radius: 999px;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 0.75rem;\n  font-weight: 800;\n}\n\n.table-region {\n  min-width: 0;\n  overflow-x: auto;\n  padding: 0.5rem;\n  background: var(--ca-surface, #fff);\n}\n\n.state-panel {\n  display: flex;\n  min-height: 17rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem;\n  text-align: center;\n\n  h3 {\n    margin: 0 0 0.45rem;\n    color: var(--ca-text-primary, #172033);\n    font-size: 1.05rem;\n    font-weight: 700;\n  }\n\n  p {\n    max-width: 28rem;\n    margin: 0 0 1rem;\n    color: var(--ca-text-secondary, #4b5870);\n    font-size: 0.84rem;\n    line-height: 1.55;\n  }\n}\n\n.loading-state,\n.empty-state,\n.error-state {\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  margin-bottom: 1rem;\n  border: 3px solid var(--ca-border, #dfe4ec);\n  border-top-color: var(--ca-primary, #0e2e80);\n  border-radius: 50%;\n  animation: zone-assets-spin 0.8s linear infinite;\n}\n\n.state-icon {\n  display: inline-flex;\n  width: 3.2rem;\n  height: 3.2rem;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 1rem;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.5rem;\n}\n\n.error-state .state-icon {\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-danger, #dc3545);\n}\n\n.btn {\n  display: inline-flex;\n  min-height: 2.5rem;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  padding: 0.55rem 0.95rem;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 0.84rem;\n  font-weight: 650;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.btn-primary {\n  border: 1px solid var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n\n  &:hover {\n    border-color: var(--ca-primary-dark, #0d2863);\n    background: var(--ca-primary-dark, #0d2863);\n    color: #fff;\n  }\n}\n\n.btn-secondary {\n  border: 1px solid var(--ca-border, #dfe4ec);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n\n  &:hover {\n    border-color: var(--ca-primary, #0e2e80);\n    background: var(--ca-surface-hover, #f8faff);\n    color: var(--ca-primary-dark, #0d2863);\n  }\n}\n\n.btn:focus-visible {\n  outline: 3px solid rgba(40, 80, 173, 0.25);\n  outline-offset: 2px;\n}\n\n.dialog-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.95rem 1.5rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n  background: var(--ca-surface, #fff);\n}\n\n.footer-note {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.76rem;\n\n  i {\n    color: var(--ca-success, #198754);\n    font-size: 0.95rem;\n  }\n}\n\n@keyframes zone-assets-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 767.98px) {\n  .dialog-header {\n    gap: 0.75rem;\n    padding: 1rem;\n  }\n\n  .dialog-heading-group {\n    gap: 0.65rem;\n  }\n\n  .dialog-heading-icon {\n    width: 2.35rem;\n    height: 2.35rem;\n    flex-basis: 2.35rem;\n    font-size: 1rem;\n  }\n\n  .dialog-body {\n    padding: 0.9rem;\n  }\n\n  .zone-summary {\n    flex-wrap: wrap;\n    gap: 0.6rem;\n  }\n\n  .summary-status {\n    margin-left: 3rem;\n  }\n\n  .table-card-heading {\n    align-items: flex-start;\n    padding: 0.9rem;\n  }\n\n  .table-region {\n    padding: 0.25rem;\n  }\n\n  .dialog-footer {\n    padding: 0.85rem 1rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
